import { lazyPage } from '../../utils/lazyPage';

const NHLBestPicksToday = lazyPage(() => import('./BestPicksToday'));
const NHLmoneyline = lazyPage(() => import('./NHLmoneyline/NHLmoneyline'));
const NHLspread = lazyPage(() => import('./NHLspread/NHLspread'));
const NHLtotal = lazyPage(() => import('./NHLtotal/NHLtotal'));
const NHLPlayerProps = lazyPage(() => import('./NHLPlayerProps/NHLPlayerProps'));

const nhlRoutes = [
  {
    path: '/nhl/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <NHLBestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/nhl/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <NHLmoneyline {...params} />
  },
  {
    path: '/nhl/spread',
    label: 'Spreads',
    renderer: (params = {}) => <NHLspread {...params} />
  },
  {
    path: '/nhl/total',
    label: 'Totals',
    renderer: (params = {}) => <NHLtotal {...params} />
  },
  {
    path: '/nhl/player-props',
    label: 'Player Props',
    renderer: (params = {}) => <NHLPlayerProps {...params} />
  }
];

export default nhlRoutes;
